<template>
  <div class="dashboard">
    <v-layout row wrap class="my-5 px-1">
      <v-flex xs12 sm12 md12>
        <v-layout wrap row justify-start class="mb-3">
          <v-flex xs6  pa-1>
            <v-text-field
              label="Search By Code, SKU, ..."
              hide-details
              solo
              v-model="searchText"
              @input="filterPurchaseOrders()"
            ></v-text-field>
          </v-flex>
          <v-flex xs3 pa-1>
            <v-autocomplete
              :items="vendors"
              solo :loading="loading"
              item-text="name"
              hide-details
              clearable
              return-object
              @change="filterPurchaseOrders()"
              v-model="vendor"
              label="Select A Vendor"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs3 pa-1>
            <v-autocomplete
              name="Source Warehouse"
              label="Source Warehouse"
              solo :loading="loading"
              hide-details
              item-text="name"
              clearable
              @change="filterPurchaseOrders()"
              :items="warehouses"
              v-model.trim="warehouse"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs2 pa-1>
            <v-autocomplete
              name="SKU"
              label="SKU"
              solo :loading="loading"
              @change="filterPurchaseOrders()"
              :items="products"
              item-text="sku"
              clearable
              item-value="sku"
              hide-details
              v-model.trim="product"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs2 pa-1>
            <v-select
              :items="['Pending', 'Purchase', 'Received', 'Partially Received']"
              hide-details
              solo :loading="loading"
              @change="filterPurchaseOrders()"
              v-model="status"
              label="Select A Status"
            ></v-select>
          </v-flex>
          <v-flex xs3 pa-1>
            <v-menu
              v-model="cDate"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template slot="activator">
                <v-text-field
                  v-model="fcreate_date"
                  label="From Date"
                  append-icon="event"
                  @change="filterPurchaseOrders()"
                  readonly
                  solo :loading="loading"
                  clearable
                  hide-details
                ></v-text-field>
              </template>
              <v-date-picker v-model="fcreate_date" @change="filterPurchaseOrders()" @input="cDate = false"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs3 pa-1>
            <v-menu
              v-model="tcDate"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template slot="activator">
                <v-text-field
                  v-model="tcreate_date"
                  label="To Date"
                  append-icon="event"
                  @change="filterPurchaseOrders()"
                  readonly
                  solo :loading="loading"
                  clearable
                  hide-details
                ></v-text-field>
              </template>
              <v-date-picker v-model="tcreate_date" @change="filterPurchaseOrders()" @input="tcDate = false"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs2 pa-1>
            <v-autocomplete
              :items="invoicers"
              hide-details
              solo :loading="loading"
              v-model="invoice_by"
              label="Select A Invoice By"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs2  pa-1>
            <v-text-field
              label="limit"
              hide-details
              solo
              v-model="limit"
            ></v-text-field>
          </v-flex>
          <v-flex xs2 px-1>
              <v-btn color="primary" block large @click="getPurchaseOrders()">load</v-btn>
            </v-flex>
          <v-flex xs2 px-1>
            <v-btn color="primary" block large @click="exportPos()">export</v-btn>
          </v-flex>
          <v-flex xs2 px-1>
            <v-btn color="primary" block large @click="goTo(`/purchase`)">new</v-btn>
          </v-flex>
        </v-layout>
        <div v-if="loading" class="text-xs-center">
          <v-progress-linear :indeterminate="true"></v-progress-linear>
        </div>
        <v-layout row wrap py-3>
          <v-flex xs12 sm12 md12>
            <v-switch label="Table View" v-model="table"></v-switch>
          </v-flex>
          <v-flex xs12 sm12 md12 v-if="!table">
              <span> {{ filteredPurchaseOrders.length}} Results </span>
              <div class="text-xs-center">
                <v-pagination
                  v-model="currentPage"
                  :length="pagesNumber"
                  :total-visible="5"
                  @input="updateVisible"
                ></v-pagination>
              </div>
          </v-flex>
        </v-layout>
        <v-layout row wrap py-3 v-if="table" class="tableDiv">
          <v-flex xs12>
            <v-data-table
              :headers="TableHeaders"
              :items="TableData"
              class="elevation-1"
            >
              <template v-slot:items="props">
                <td v-for="(h, i) in TableHeaders" :key="'-val-' + i">
                
                  <span
                    v-if="h.value != 'barcode'"
                    v-clipboard:copy="props.item[h.value]"
                    v-clipboard:success="clipboardSuccessHandler"
                    v-clipboard:error="clipboardErrorHandler"
                  > {{ props.item[h.value] }} 
                    <!-- <v-icon size="14" @click="goTo(`/purchase/${props.item.key}`)">open_in_new</v-icon> -->
                  </span>
                  <span
                    v-if="h.value == 'barcode'"
                    style="cursor:pointer;color:#2196f3;"
                    @click="pathNewWindow(`/purchase/${props.item['po_key']}`)"
                  > {{ props.item[h.value] }}<v-icon color="red" size="14">open_in_new</v-icon>
                  </span>
                </td>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
        <v-layout row wrap py-3 v-if="!table">
          <v-flex xs12 sm12 md12 v-for="po in visiblePurchaseOrders" :key="po.key" mb-1>
            <v-card>
              <v-card-text>
                <v-layout row wrap align-center>
                  <v-flex xs3>
                    <div style="font-size:11px;font-weight:600;">ASN</div>
                    <div class="subheadline">{{ po.asn }}</div>
                  </v-flex>
                  <v-flex xs3>
                    <div style="font-size:11px;font-weight:600;">KEY</div>
                    <div class="subheadline"
                      v-clipboard:copy="po.key"
                      v-clipboard:success="clipboardSuccessHandler"
                      v-clipboard:error="clipboardErrorHandler"
                    >{{ po.key }}</div>
                  </v-flex>
                  <v-flex xs3>
                    <div style="font-size:11px;font-weight:600;">Creator</div>
                    <div class="subheadline">{{ po.creator }}</div>
                  </v-flex>
                  <v-flex xs3>
                    <div style="font-size:11px;font-weight:600;">NUMBER</div>
                    <div class="subheadline"
                      v-clipboard:copy="po.number"
                      v-clipboard:success="clipboardSuccessHandler"
                      v-clipboard:error="clipboardErrorHandler"
                    >{{ po.number }}</div>
                  </v-flex>
                  <v-flex xs3>
                    <div style="font-size:11px;font-weight:600;">CREATE DATE</div>
                    <div class="subheadline">{{ po.create_date }}</div>
                  </v-flex>
                  <v-flex xs3>
                    <div style="font-size:11px;font-weight:600;">STATUS</div>
                    <div class="subheadline">{{ po.status }}</div>
                  </v-flex>
                  <v-flex xs3>
                    <div style="font-size:11px;font-weight:600;" >VENDOR</div>
                    <div class="subheadline" v-if="po.v"
                      v-clipboard:copy="po.v.name"
                      v-clipboard:success="clipboardSuccessHandler"
                      v-clipboard:error="clipboardErrorHandler"
                    >{{ po.v.name }}</div>
                  </v-flex>
                  <v-flex xs3>
                    <div style="font-size:11px;font-weight:600;">WH</div>
                    <div class="subheadline"
                      v-clipboard:copy="po.wh"
                      v-clipboard:success="clipboardSuccessHandler"
                      v-clipboard:error="clipboardErrorHandler"
                    >{{ po.wh }}</div>
                  </v-flex>
                  <v-flex xs3>
                    <div style="font-size:11px;font-weight:600;">INVOICE DATE</div>
                    <div class="subheadline">{{ po.invoice_date }}</div>
                  </v-flex>
                  <v-flex xs3>
                    <div style="font-size:11px;font-weight:600;">EXPECTED DATE</div>
                    <div class="subheadline">{{ po.expected_date }}</div>
                  </v-flex>
                  <v-flex xs12 pt-3>
                    <v-expansion-panel expand>
                      <v-expansion-panel-content>
                        <div slot="header">ITEMS</div>
                        <v-card>
                          <v-card-text>
                            <v-layout row wrap>
                              <v-flex xs12>
                                <v-layout row wrap class="text-xs-left">
                                  <v-flex xs3>
                                    <div style="font-size:10px;font-weight:600;">SKU</div>
                                  </v-flex>
                                  <v-flex xs3>
                                    <div style="font-size:10px;font-weight:600;">QT.</div>
                                  </v-flex>
                                  <v-flex xs3 px-1>
                                    <div style="font-size:10px;font-weight:600;">PRICE</div>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                              <v-flex xs12 v-for="(item, it) in po.items" py-1 :key="'item-'+it">
                                <v-layout row wrap class="text-xs-left">
                                  <v-flex xs3
                                    v-clipboard:copy="item.sku"
                                    v-clipboard:success="clipboardSuccessHandler"
                                    v-clipboard:error="clipboardErrorHandler"
                                  >
                                    {{item.sku}}
                                  </v-flex>
                                  <v-flex xs3>
                                    {{item.quantity}}
                                  </v-flex>
                                  <v-flex xs3 px-1>
                                    {{item.price}}
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </v-card-text>
                        </v-card>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-flex>
                  
                </v-layout>
              </v-card-text>
              <v-card-actions dense>
                <v-spacer></v-spacer>
                <v-btn color="primary" dark small @click="goTo(`/purchase/${po.key}`)">Edit</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout row wrap py-3 v-if="!table">
          <v-flex xs12 sm12 md12>
            <div class="text-xs-center">
              <v-pagination
                v-model="currentPage"
                :length="pagesNumber"
                :total-visible="7"
                @input="updateVisible"
              ></v-pagination>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import {firebase, db, auth, store} from '@/fb'
import { titleCase, randomString } from '@/customFunction'
import axios from 'axios';
import json2csv from 'json2csv'

export default {
  data() {
    return {
      searchText:'',
      loading:false,
      currentPage: 1,
      pageSize: 7,
      pagesNumber:0,
      purchaseOrders:[],
      filteredPurchaseOrders:[],
      visiblePurchaseOrders:[],
      vendors:[],
      warehouses:[],
      products:[],
      vendor:null,
      warehouse:null,
      product:null,
      status:null,
      fcreate_date:null,
      cDate:null,
      tcDate:null,
      tcreate_date:null,
      invoicers:[],
      invoice_by:null,
      TableHeaders:[],
      TableData:[],
      table:true,
      limit:30,
    }
  },
  props:{
    uid:{
      default:null
    }
  },
  methods:{
    goTo(path) {
      this.$router.push(path)
    },
    pathNewWindow(p){
      window.open('https://ashyaatcrm.firebaseapp.com' + p, '_blank').focus();
    },
		updateVisible() {
      this.sortByDate()
      this.visiblePurchaseOrders = this.filteredPurchaseOrders.slice((this.currentPage -1) * this.pageSize, ((this.currentPage -1) * this.pageSize) + this.pageSize);
      this.loading = false
    },
    sortByDate(){
      this.filteredPurchaseOrders = this.filteredPurchaseOrders.sort((a, b)=>a.timestamp - b.timestamp)
    },
    getPagesNumber(){
      if (this.filteredPurchaseOrders.length % this.pageSize == 0) {
        this.pagesNumber = parseInt(this.filteredPurchaseOrders.length / this.pageSize)
      } else {
        this.pagesNumber = parseInt(this.filteredPurchaseOrders.length / this.pageSize) + 1
      }
		},
		filterPurchaseOrders() {
      this.loading = true
			this.filteredPurchaseOrders = this.purchaseOrders
      .filter(x=>{
        if(this.searchText){
          this.searchText = this.searchText.toLowerCase()
          for (const key in x) {
            if (Object.hasOwnProperty.call(x, key) && typeof x[key] == 'string') {
              if(x[key] && x[key].toLowerCase().includes(this.searchText)) {
                return x
              }
            }
          }
        } else {
          return x
        }
      })
      .filter(x=>{
        if(this.vendor && Object.keys(this.vendor).length) {
          if(x.v.key == this.vendor.key) {
            return x
          }
        } else {
          return x
        }
      })
      .filter(x=>{
        if(this.warehouse) {
          if(x.wh == this.warehouse) {
            return x
          }
        } else {
          return x
        }
      })
      .filter(x=>{
        if(this.product) {
          if(x.items.map(x=>x.sku).includes(this.product)) {
            return x
          }
        } else {
          return x
        }
      })
      .filter(x=>{
        if(this.status) {
          if(x.status == this.status) {
            return x
          }
        } else {
          return x
        }
      })
      .filter(x=>{
        if(this.invoice_by) {
          if(x.invoice_by == this.invoice_by) {
            return x
          }
        } else {
          return x
        }
      })
      .filter(x=>{ // create date
        if(!this.fcreate_date) return x
        if(!this.tcreate_date) return x
        let t = new Date(x.create_date).getTime()
        let z = new Date(this.fcreate_date).getTime()
        let y = new Date(this.tcreate_date).getTime()
        if (t >= z && t <= y) return x
      })
      .sort((a, b) => a.timestamp - b.timestamp)
      this.getPagesNumber()
      this.currentPage = 1
			this.updateVisible()
      this.loadTable()
		},
		clipboardSuccessHandler ({ value, event }){
      this.$emit('snackbarNotification', `Copied`, 'success')
    },
    clipboardErrorHandler ({ value, event }) {
      this.$emit('snackbarNotification', `Failed`, 'error')
    },
    async getPurchaseOrders(){
      this.loading = true
      let purchaseOrders = await store.collection(`purchaseOrders`)
      .orderBy("timestamp", "desc")
      .limit(parseInt(this.limit))
      .get().then(x=>x.docs.map((y, i)=>{
        if(i==x.docs.length-1) this.last = y
        return {
          ...y.data(), 
          key:y.id,
        }
      }))
      this.purchaseOrders = purchaseOrders
      this.filterPurchaseOrders()
    },
    async loadVendors(){
      this.loading = true
      let a = await db.ref('settings/vendors').once('value').then(x=>x.val())
      if(a){
        let b = Object.keys(a)
        this.vendors = Object.values(a).map((x, i)=>{
          return {
            ...x,
            key:b[i]
          }
        })
      }
      this.vendor = {}
      this.loading = false
    },
    async getWarehouses(){
      this.loading = true
      this.warehouses = await store.collection('warehouses').get().then(x=>x.docs.map(y=>y.data()))
      console.log(this.warehouses)
      this.loading = false
    },
    async loadProducts(){
      return new Promise(async (res, rej)=>{
        this.loading = true
        let a = await db.ref(`productsCoreLite`)
        .once('value').then(x=>x.val())
        let b = Object.keys(a)
        let c = Object.values(a).map((x,i)=>{
          return {
            ...x, 
            key:b[i],
          }})
        this.products = c
        this.loading = false
        res(true)
      })
    },
    async LoadInvoices(){
      let a = await db.ref('settings/invoiceby').once('value').then(x=>x.val())
      if(a) {
        let b = Object.values(a).map(x=>x.name)
        this.invoicers = b
      }
    },
    exportData(data, name){
      console.log(data)
      let a = json2csv.parse(data)
      console.log(a)
      let csvContent = "data:text/csv;charset=utf-8," 
      var encodedUri =  csvContent + encodeURIComponent(a);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      let n = name ? name : 'po_export'
      link.setAttribute("download", `${n}.csv`);
      document.body.appendChild(link); // Required for FF

      link.click();
    },
    exportPos() {
      let pos = this.filteredPurchaseOrders
      console.log(pos)
      let epo = [];
      for (let i = 0; i < pos.length; i++) {
        const po = pos[i];
        let ks = Object.keys(po).filter(x=> typeof po[x] == 'string')
        let dpo = {}
        ks.forEach(x=> dpo[x] = po[x])
        let post = po.status_timeline ? Object.values(po.status_timeline) : []
        let postst = {}
        post.forEach(x=>postst[x.status]=x.date)
        console.log(dpo)
        if (po.rec_items && po.rec_items.length) {
          for (let h = 0; h < po.rec_items.length; h++) {
            const item = po.rec_items[h];
            let a = {
              ...dpo,
              ...po.v,
              ...item,
              ...postst,
              po_key:po.key,
              item_name:this.products.filter(x=>x.sku == item.sku)[0].item_name,
              quantity_expected:po.items.filter(x=>x.sku == item.sku).length?po.items.filter(x=>x.sku == item.sku)[0].quantity:0,
              received:true,
            }
            epo.push(a)
          }
        }
        if (!po.rec_items || !po.rec_items.length) {
          for (let h = 0; h < po.items.length; h++) {
            const item = po.items[h];
            let a = {
              ...dpo,
              ...po.v,
              ...item,
              ...postst,
              po_key:po.key,
              item_name:this.products.filter(x=>x.sku == item.sku)[0].item_name,
              quantity_expected:po.items.filter(x=>x.sku == item.sku).length?po.items.filter(x=>x.sku == item.sku)[0].quantity:0,
            }
            epo.push(a)
          }
        }
      }
      this.exportData(epo)
    },
    loadTable() {
      this.loading = true
      console.table(this.filteredPurchaseOrders.filter(x=>!x.rec_items))
      let pos = this.filteredPurchaseOrders.filter(x=>x.rec_items)
      let epo = [];
      for (let i = 0; i < pos.length; i++) {
        const po = pos[i];
        let ks = Object.keys(po).filter(x=> typeof po[x] == 'string')
        let dpo = {}
        ks.forEach(x=> dpo[x] = po[x])
        let post = po.status_timeline ? Object.values(po.status_timeline) : []
        let postst = {}
        post.forEach(x=>postst[x.status]=x.date)
        for (let h = 0; h < po.rec_items.length; h++) {
          const item = po.rec_items[h];
          let a = {
            ...dpo,
            ...po.v,
            ...item,
            ...postst,
            item_name:this.products.filter(x=>x.sku == item.sku).length?this.products.filter(x=>x.sku == item.sku)[0].item_name:'',
            quantity_expected:po.items.filter(x=>x.sku == item.sku).length?po.items.filter(x=>x.sku == item.sku)[0].quantity:0,
            quantity_received:item.quantity,
            received:true,
            po_key:po.key,
          }
          epo.push(a)
        }
        if(!po.rec_items.length) {
          for (let h = 0; h < po.items.length; h++) {
            const item = po.items[h];
            let a = {
              ...dpo,
              ...po.v,
              ...item,
              ...postst,
              item_name:this.products.filter(x=>x.sku == item.sku).length?this.products.filter(x=>x.sku == item.sku)[0].item_name:'',
              quantity_expected:po.items.filter(x=>x.sku == item.sku).length?po.items.filter(x=>x.sku == item.sku)[0].quantity:0,
              po_key:po.key,
            }
            epo.push(a)
          }
        }
      }
      let HH = ['country', 'wh',	'status',	'barcode',	'asn',	'sku',	'item_name',	'quantity_expected',	'quantity_received', 'price',	'currency',	'name',	'create_date',	'expected_date',	'invoice_date',	'invoice_by',	'ship_by']
      this.TableHeaders = HH.map(x=>{return {text:x.toUpperCase(), value:x}})
      this.TableData = epo
      this.loading = false
    }
  },
  watch:{
    
  },
  async created(){
    await this.loadProducts()
    this.getWarehouses()
    this.loadVendors()
    this.LoadInvoices()
    this.getPurchaseOrders()
  }
}
</script>

<style>
.tableDiv ::-webkit-scrollbar-thumb
{
	background-color: #0d47a1;
	border-radius:  0; 
}

.tableDiv td {
    border-width: 0 1px 0 1px;
    border-style: solid;
    border-color: #e8e8e8;
    padding:0 5px !important;
}
</style>
